import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import {
  mediaQuery,
  pxToRem,
  responsiveFontSize,
  stack,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const radioButtonWrapper = css`
  display: flex;
  margin: ${stack(spacing.lg)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${stack(spacing.sm)};
    `,
  )}
`;

export const radioButtonLabelText = css`
  flex-grow: 1;
  margin: ${pxToRem(spacing.base)} 0 0 ${pxToRem(spacing.xs)};
  ${responsiveFontSize(text.sm)};
`;
